export default __webpack_public_path__ + "static/media/2_fideltour.2113894b.svg";